import { render, staticRenderFns } from "./CompanyInstructionSubTree.vue?vue&type=template&id=0b0dbf3a&scoped=true&"
import script from "./CompanyInstructionSubTree.vue?vue&type=script&lang=js&"
export * from "./CompanyInstructionSubTree.vue?vue&type=script&lang=js&"
import style0 from "./CompanyInstructionSubTree.vue?vue&type=style&index=0&id=0b0dbf3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0dbf3a",
  null
  
)

export default component.exports